import api from "PFCore/api";
import { PaginatedCollection } from "PFTypes";
import { AccessRequest } from "PFTypes/access_request";
import { QueryParams } from "PFTypes/query_params";

export type AccessRequestsResponse = PaginatedCollection<AccessRequest[]>;

export const fetchAccessRequests = (
  params: Pick<QueryParams, "page" | "perPage"> = {}
): Promise<AccessRequestsResponse> =>
  api({
    url: "admin/access_requests",
    params,
    headers: {
      apiVersion: 1
    }
  });
